import { $, $$, throttle, $id, addEventListenerAll } from '../../helper/utils';
import { MOBILMEDIA } from '../../helper/constants';

const isIE = document.documentElement.classList.contains('ie');
const NAVOPENDELAY = isIE ? 0 : 60;
const desktopNav = $('.desktop-nav');
const backdrop = desktopNav.querySelector('.backdrop');
const header = $('#header');
const headerHeight = header.offsetHeight;
const desktopLang = $('#header .lang-select > button');
const mobileNav = $('.mobile-nav');
const navOpen = {
    el: null,
    subnav: null,
};
const subnavOpen = {
    el: null,
    subnav: null,
};
const treshold = headerHeight * 3;
let lastScroll = 0;
let smallHeader = false;
let timeout = null;
let closeNavTimeout = null;
let openNavTimeout = null;
let closeSubnavTimeout = null;
let openSubnavTimeout = null;

// const logoTween = TweenMax.to('#header .logo svg', 0.375, {
//     attr: { viewBox: '140 10 160.5 70.9' },
//     ease: Sine.easeOut,
//     paused: true,
//     delay: 0.3,
// });

const hideHeader = (top) => {
    if (
        (navOpen === true && top > headerHeight && smallHeader === true)
        || smallHeader === false
        || (mobileNav.style.opacity !== '' && mobileNav.style.opacity !== '0')
    ) {
        return;
    }

    smallHeader = false;
    clearTimeout(timeout);
    timeout = null;
    requestAnimationFrame(() => {
        header.classList.remove('small');
    });
};

const scrollCheck = throttle(() => {
    const top = window.pageYOffset || document.documentElement.scrollTop;

    if (MOBILMEDIA.matches) {
        if (top < treshold) {
            if (top <= headerHeight || (top > lastScroll && smallHeader === true)) {
                hideHeader(top);
            }

            lastScroll = top;
            return;
        }

        // scroll up show
        if (top < (lastScroll - 20) && smallHeader === false) {
            smallHeader = true;
            timeout = setTimeout(() => {
                requestAnimationFrame(() => {
                    header.classList.add('small');
                });
            }, 300);

            // scroll down hide
        } else if (top > (lastScroll + 20)) {
            hideHeader(top);
        }
    } else {
        // eslint-disable-next-line
        if (top > headerHeight) {
            if (smallHeader === true) {
                return;
            }

            smallHeader = true;
            timeout = setTimeout(() => {
                header.classList.add('small');
            }, 200);
        } else {
            hideHeader(top);
        }
    }

    lastScroll = top;
}, 150);

// scrollCheck();
window.addEventListener('scroll', scrollCheck);

let tween = null;
let subnavTween = null;
const tl = new TimelineLite({
    paused: true,
    onComplete() {
        desktopNav.setAttribute('aria-hidden', false);
    },
    onReverseComplete() {
        desktopNav.setAttribute('aria-hidden', true);
    },
});

tl
    .set(backdrop, { pointerEvents: 'auto' })
    .to(desktopNav, 0.275, {
        pointerEvents: 'auto',
        visibility: 'visible',
    });
// .to(backdrop, 0.275, {
//     pointerEvents: 'auto',
//     opacity: 0.2,
//     ease: Sine.easeOut,
// }, '-=0.275');

// remove nav opening tween from timeline
const removeNavTweens = () => {
    const childTweens = tl.getChildren();
    if (childTweens.length >= 3) {
        tl.remove(childTweens.splice(2, childTweens.length - 1));
    }
};

const closeSubNav = () => {
    // check if no nav element is open
    if (subnavOpen.el === null) {
        return;
    }

    if (openSubnavTimeout !== null) {
        clearTimeout(openSubnavTimeout);
        openSubnavTimeout = null;
    }

    subnavOpen.el.classList.remove('open');

    requestAnimationFrame(() => {
        subnavTween.reverse();

        subnavOpen.el = null;
        subnavOpen.subnav = null;

        clearTimeout(closeSubnavTimeout);
        closeSubnavTimeout = null;
    });
};

const closeNav = () => {
    // check if no nav element is open
    if (navOpen.el === null) {
        return;
    }

    if (openNavTimeout !== null) {
        clearTimeout(openNavTimeout);
        openNavTimeout = null;
    }

    closeSubNav();

    const wait = subnavOpen.el !== null ? subnavTween.totalDuration() * 1000 : 0;
    setTimeout(() => {
        navOpen.el.classList.remove('open');
        removeNavTweens();
        requestAnimationFrame(() => {
            TweenMax.to(navOpen.subnav, 0.225, {
                yPercent: -100,
                ease: Sine.easeIn,
                startAt: {
                    yPercent: 0,
                    y: 0,
                },
            });

            tl.reverse();

            navOpen.el = null;
            navOpen.subnav = null;

            clearTimeout(closeNavTimeout);
            closeNavTimeout = null;
        });
    }, wait);
};

export default () => {
    // stop closing nav if mouse enters subnav container
    desktopNav.addEventListener('mouseenter', () => {
        clearTimeout(closeNavTimeout);
        closeNavTimeout = null;
    });

    // close navi on header hover
    header.addEventListener('mouseover', () => {
        if (openNavTimeout !== null) {
            clearTimeout(openNavTimeout);
            openNavTimeout = null;
        }

        if (closeNavTimeout === null) {
            closeNavTimeout = setTimeout(closeNav, 600);
        }
    });

    // close navi on backdrop hover
    desktopNav.addEventListener('mouseover', throttle((e) => {
        // cancel when over open subnav
        if (e.target === navOpen.subnav || navOpen.subnav.contains(e.target)) {
            clearTimeout(closeNavTimeout);
            closeNavTimeout = null;
            clearTimeout(openNavTimeout);
            openNavTimeout = null;
        } else if (closeNavTimeout === null && e.target === backdrop) {
            closeNavTimeout = setTimeout(closeNav, 500);
        }
    }, 80));

    // eslint-disable-next-line
    desktopLang && desktopLang.addEventListener('click', function () {
        this.focus();
    }, { passive: true });

    // close desktop nav on backdrop click
    addEventListenerAll([header, backdrop], 'click', closeNav, { passive: true });

    // handle the slide in/out of subnavs
    addEventListenerAll($$('.nav-link'), 'mouseenter', function () {
        // if link has no subnav, close any open subnav and exit
        if (this.classList.contains('has-sub') === false) {
            closeNav();
            return;
        }

        clearTimeout(openNavTimeout);
        openNavTimeout = null;

        clearTimeout(closeNavTimeout);
        closeNavTimeout = null;

        const subnav = $id(this.dataset.subnav);

        if (subnav === null) {
            console.warn('Subnav element not found');
            return;
        }

        openNavTimeout = setTimeout(() => {
            openNavTimeout = null;

            if (navOpen.el === this) {
                // closeNav();
            } else if (navOpen.el !== null) {
                // remove tween from previous active subnav
                tl.remove(tween);

                // switch open nav
                TweenMax.set(navOpen.subnav, { yPercent: -100, y: 0 });
                TweenMax.set(subnav, { yPercent: 0, y: 0 });
                navOpen.el.classList.remove('open');
                this.classList.add('open');

                navOpen.el = this;
                navOpen.subnav = subnav;
            } else {
                this.classList.add('open');
                navOpen.el = this;
                navOpen.subnav = subnav;

                // just to make sure there aren't any old tweens left
                removeNavTweens();

                requestAnimationFrame(() => {
                    tl.add(tween = TweenMax.to(subnav, 0.275, {
                        yPercent: 0,
                        ease: Sine.easeOut,
                        startAt: {
                            yPercent: -100,
                            y: 0,
                        },
                    }), '-=0.175');
                    tl.play();
                });
            }
        }, navOpen.el !== null ? NAVOPENDELAY : 90);
    });

    // handle the slide in/out of subnavs
    addEventListenerAll($$('.subnav-link.l1'), 'mouseenter', function () {
        // if link has no subnav, close any open subnav and exit
        if (this.classList.contains('has-sub') === false) {
            closeSubNav();
            return;
        }

        clearTimeout(openSubnavTimeout);
        openSubnavTimeout = null;

        clearTimeout(closeSubnavTimeout);
        closeSubnavTimeout = null;

        const subnav = $id(this.dataset.subnav);

        if (subnav === null) {
            console.warn('Subnav element not found');
            return;
        }

        openSubnavTimeout = setTimeout(() => {
            openSubnavTimeout = null;

            if (subnavOpen.el === this) {
                // closeNav();
            } else if (subnavOpen.el !== null) {
                // remove tween from previous active subnav
                tl.remove(tween);

                // switch open nav
                TweenMax.set(subnavOpen.subnav, { yPercent: 0, y: 0 });
                TweenMax.set(subnav, { yPercent: 100, y: 0 });
                subnavOpen.el.classList.remove('open');
                this.classList.add('open');

                subnavOpen.el = this;
                subnavOpen.subnav = subnav;
            } else {
                this.classList.add('open');
                subnavOpen.el = this;
                subnavOpen.subnav = subnav;

                requestAnimationFrame(() => {
                    subnavTween = TweenMax.to(subnav, 0.275, {
                        yPercent: 100,
                        ease: Sine.easeOut,
                        startAt: {
                            yPercent: 0,
                            y: 0,
                        },
                    });
                });
            }
        }, subnavOpen.el !== null ? NAVOPENDELAY : 90);
    });
};
